import React, { Component } from 'react';

import GenericText from 'Components/GenericText';
import RampUnit from '../utils/Playwire/RampUnit';
import DocumentHeadFields from 'Components/DocumentHeadFields';

import { withLocationWrapper } from '../utils/HOC_LocationWrapper';

class ErrorPage extends Component {

  render() {
    const getTextId = props => {
      switch (errorCode) {
        case '403':
          return 'forbidden';
        case '404':
          return 'pageNotFound';
        case '500':
          return 'unknownError';
        default:
          return 'unknownError';
      }
    };
    const loadAds = true;
    let { errorCode, errorType, errorMessage, location } = this.props;
    errorCode = errorCode ? errorCode : this.props.routes[1].errorCode;
    if (errorCode && !location.pathname.match(/^\/error/))
      console.warn(errorCode, errorType, errorMessage);
    return (
      <main>
        <DocumentHeadFields documentTitle="Error: Page Not Found" />
        <div className="Page__container Page__container--no-padding">
          <RampUnit type="leaderboard_atf" id="top" />
        </div>
        <div className="Page__container Page__container--main">
          <section className="ContentBlock">
            <div className="ContentBlock__content">
              <GenericText
                contentId={getTextId(errorCode)}
                extraClass=" GenericText--full-screen"
              />
            </div>
          </section>
        </div>
      </main>
    );
  }
}

export default withLocationWrapper(ErrorPage);
